const GameVisual = ({ short }) => (
  <div className="relative flex h-full flex-col items-center justify-center overflow-hidden bg-gradient-to-br from-[#0B0B0E] via-[#12060a] to-[#050505]">
    <div
      aria-hidden="true"
      className="absolute h-40 w-40 rounded-full opacity-40 blur-[60px]"
      style={{ background: "#E50914" }}
    />
    <div aria-hidden="true" className="absolute left-3 top-3 h-5 w-5 border-l-2 border-t-2 border-[#E50914]/70" />
    <div aria-hidden="true" className="absolute right-3 top-3 h-5 w-5 border-r-2 border-t-2 border-[#E50914]/70" />
    <div aria-hidden="true" className="absolute bottom-3 left-3 h-5 w-5 border-b-2 border-l-2 border-[#E50914]/70" />
    <div aria-hidden="true" className="absolute bottom-3 right-3 h-5 w-5 border-b-2 border-r-2 border-[#E50914]/70" />
    <span className="px-3 text-center font-display text-lg font-extrabold tracking-[0.08em] text-zinc-100 drop-shadow-[0_0_18px_rgba(229,9,20,0.55)] sm:text-2xl">
      {short}
    </span>
    <span className="mt-3 rounded-full border border-[#E50914]/50 bg-[#E50914]/10 px-4 py-1 font-mono-code text-[9px] uppercase tracking-[0.3em] text-[#FF2A3B]">
      Press Start
    </span>
  </div>
);

const DashboardVisual = () => (
  <div className="flex h-full bg-[#0A0A0C]">
    <div className="flex w-1/5 flex-col gap-2 border-r border-[#1A1A20] bg-[#101014] p-3">
      <div className="h-2 w-3/4 rounded bg-[#E50914]/70" />
      <div className="h-2 w-full rounded bg-zinc-800" />
      <div className="h-2 w-full rounded bg-zinc-800" />
      <div className="h-2 w-2/3 rounded bg-zinc-800" />
    </div>
    <div className="flex-1 space-y-3 p-4">
      <div className="grid grid-cols-3 gap-2">
        <div className="rounded-lg border border-[#22222A] bg-[#101014] p-2">
          <div className="h-1.5 w-2/3 rounded bg-zinc-700" />
          <div className="mt-1.5 h-3 w-1/2 rounded bg-[#E50914]" />
        </div>
        <div className="rounded-lg border border-[#22222A] bg-[#101014] p-2">
          <div className="h-1.5 w-2/3 rounded bg-zinc-700" />
          <div className="mt-1.5 h-3 w-1/2 rounded bg-zinc-600" />
        </div>
        <div className="rounded-lg border border-[#22222A] bg-[#101014] p-2">
          <div className="h-1.5 w-2/3 rounded bg-zinc-700" />
          <div className="mt-1.5 h-3 w-1/2 rounded bg-zinc-600" />
        </div>
      </div>
      <div className="rounded-lg border border-[#22222A] bg-[#101014] p-3">
        <svg viewBox="0 0 200 48" className="h-16 w-full">
          <polyline
            points="0,40 25,32 50,36 75,22 100,26 125,14 150,18 175,8 200,12"
            fill="none"
            stroke="#E50914"
            strokeWidth="2.5"
            strokeLinecap="round"
          />
          <polyline
            points="0,44 25,42 50,44 75,38 100,40 125,34 150,36 175,30 200,32"
            fill="none"
            stroke="#3F3F46"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </div>
    </div>
  </div>
);

const BusinessVisual = () => (
  <div className="flex h-full flex-col bg-[#0A0A0C]">
    <div className="flex items-center justify-between border-b border-[#1A1A20] px-4 py-2.5">
      <div className="h-2 w-10 rounded bg-[#E50914]" />
      <div className="flex gap-2">
        <div className="h-1.5 w-8 rounded bg-zinc-700" />
        <div className="h-1.5 w-8 rounded bg-zinc-700" />
        <div className="h-1.5 w-8 rounded bg-zinc-700" />
      </div>
    </div>
    <div className="flex flex-1 flex-col justify-center gap-3 px-6">
      <div className="h-3.5 w-4/5 rounded bg-zinc-200" />
      <div className="h-3.5 w-3/5 rounded bg-zinc-500" />
      <div className="mt-1 h-2 w-full rounded bg-zinc-800" />
      <div className="h-2 w-5/6 rounded bg-zinc-800" />
      <div className="mt-2 flex gap-2">
        <div className="h-6 w-20 rounded-full bg-[#E50914]" />
        <div className="h-6 w-20 rounded-full border border-zinc-700" />
      </div>
    </div>
    <div className="grid grid-cols-3 gap-2 px-6 pb-4">
      <div className="h-10 rounded-lg border border-[#22222A] bg-[#101014]" />
      <div className="h-10 rounded-lg border border-[#22222A] bg-[#101014]" />
      <div className="h-10 rounded-lg border border-[#22222A] bg-[#101014]" />
    </div>
  </div>
);

export const ProjectVisual = ({ project }) => {
  return (
    <div className="flex h-full flex-col overflow-hidden">
      <div className="flex items-center gap-2 border-b border-[#1A1A20] bg-[#101014] px-4 py-2.5">
        <span className="h-2.5 w-2.5 rounded-full bg-[#E50914]/80" />
        <span className="h-2.5 w-2.5 rounded-full bg-zinc-700" />
        <span className="h-2.5 w-2.5 rounded-full bg-zinc-700" />
        <span className="ml-2 flex-1 truncate rounded-md bg-[#050505] px-3 py-1 font-mono-code text-[10px] text-zinc-500">
          {project.slug}
        </span>
      </div>
      <div className="min-h-0 flex-1">
        {project.visual === "game" && <GameVisual short={project.short} />}
        {project.visual === "dashboard" && <DashboardVisual />}
        {project.visual === "business" && <BusinessVisual />}
      </div>
    </div>
  );
};
